import script from "./Tags.vue?vue&type=script&setup=true&lang=js"
export * from "./Tags.vue?vue&type=script&setup=true&lang=js"

import "./Tags.vue?vue&type=style&index=0&id=6d94023c&lang=css"

const __exports__ = script;

export default __exports__